<template>
    <div>
        <ag-grid-vue
            ref="agGridTable"
            :components="components"
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowData="limitedTableList"
            rowSelection="multiple"
            colResizeDefault="shift"
            :animateRows="true"
            :floatingFilter="false"
            :pagination="true"
            :paginationPageSize="paginationPageSize"
            :suppressPaginationPanel="true"
            :enableRtl="$vs.rtl"
            @cell-value-changed="onCellValueChanged"
            @row-selected="CellvalueSelectDeselect"
            @cell-clicked="cellSingleClickedProject"
            @grid-ready="onGridReady">
        </ag-grid-vue>
        <vs-row  class="mt-2" vs-type="flex" vs-justify="space-between">
      <vs-col
        vs-xs="12"
        vs-sm="6"
        vs-lg="4"
        vs-type="flex"
        vs-justify="start"
        vs-align="center"
      >
        <!-- page limit select view -->
        <span style="font-size: 12px">
          Show
          <select
            v-model="pageLimitSet"
            style="
              background: #fff !important;
              height: 40px;
              width: 70px;
              font-size: 12px;
            "
            class="form-control vs-select--input vs-select--input-con"
          >
            <option
              v-for="(option, index) of pageLimitOPtion"
              :key="index"
              :value="option.value"
              :label="option.value"
              class="vs-select--options"
            >
              {{ option.value }}
            </option></select
          >entry
        </span>
      </vs-col>
      <vs-col vs-xs="12" vs-sm="6" vs-lg="8">
        <pagination
          style="float: right"
          :meta="meta"
          @page-change="ProjecthandlePageChange"
        />
      </vs-col>
    </vs-row>
    </div>
</template>

<script>
import Pagination from '@/components/common/pagination'
import {projectList, projectUpdate } from '@/api/task-project.js'
import router from '@/router'
import { AgGridVue } from 'ag-grid-vue'
import { Project } from './mixins/project.js'
import { mapGetters, mapActions } from 'vuex'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererActionsProject from './components/CellRendererActionsProject.vue'
export default {
  name: 'Project-Listing',
  components: {
    AgGridVue,
    CellRendererActionsProject,
    router,
    Pagination
  },
  props: {
    customer_id: {
      required: true
    }
  },
  mixins: [Project],
  data () {
    return {
      isRowSelected: false,
      ListOfProject: [],
      gridOptions: {},
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
        suppressMenu: true
      },
      components: {
        CellRendererActionsProject
      },
      columnDefs: [
        {
          headerName: '#',
          field: 'row_index',
          filter: true,
          minWidth: 60,
          resizable: true,
          editable: false
        },
        {
          headerName: 'Name',
          field: 'name',
          minWidth: 200,
          filter: true,
          editable: false,
          cellStyle: { color: 'blue' }
        },
        {
          headerName: 'Details',
          field: 'details',
          filter: true,
          editable: false,
          minWidth: 150
        },
        {
          headerName: 'No. of Task',
          field: 'no_of_tasks',
          filter: true,
          editable: false,
          minWidth: 100
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['get_task_deleted_id']),
    limitedTableList () {
      let tableList = []
      if (this.pageLimitSet === 'all') {
        tableList = this.ListOfProject
      } else {
        const TableLength = this.ListOfProject.length
        if (this.pageLimitSet >= TableLength) {
          tableList = this.ListOfProject
        } else {
          for (let i = 0; i < this.pageLimitSet; i++) {
            tableList.push(this.ListOfProject[i])
          }
        }
      }

      return tableList
    }
  },
  watch: {
    get_task_deleted_id () {
      if (this.get_task_deleted_id) {
        const table = this.ListOfProject
        const dlt_id = table.findIndex(
          (item) => item.id === this.get_task_deleted_id
        )
        table.splice(dlt_id, 1)
        table.map((row, index) => {
          row.row_index = index + 1
        })
        this.ListOfProject = table
      }
    },
    pageLimitSet () {
      this.ProjecthandlePageChange(1)
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  methods: {
    ...mapActions(['SET_DEFAULT_ID']),
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    },
    cellSingleClickedProject (params) {
      if (params.column.colId === 'name') {
        this.$router
          .push({
            name: 'project-details',
            params: { id: params.data.id }
          })
          .catch(() => {})
      }
       
    },
    
    CellvalueSelectDeselect () {
      this.gridApi = this.gridOptions.api
      const selectedNodes = this.gridApi.getSelectedNodes()
      // console.log(selectedNodes)
      if (selectedNodes) {
        const selecttedNode = this.gridApi.getSelectedNodes()
        const selectedRows = selecttedNode.map((node) => node.data)
        if (selectedRows.length > 1) {
          this.isRowSelected = true
        } else {
          this.isRowSelected = false
        }
      } else {
        this.isRowSelected = false
      }
    },

    getSelectedRows () {
      const selectedNodes = this.gridApi.getSelectedNodes()
      const selectedData = selectedNodes.map((node) => node.data)
      return selectedData
    },
    onCellValueChanged (params) {
      const data = []
      data.colId = params.column.getId()
      data.proj_id = params.data.id
      if (data.colId === 'name') {
        data.fieldvalue = params.data.name
        data.colId = 'name'
        if (data.fieldvalue === '') {
          this.$vs.notify({
            title: 'Warning',
            text: 'Name field must be greater than 0',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 8000,
            position: 'top-center'
          })
          return false
        }
      } else if (data.colId === 'details') {
        data.fieldvalue = params.data.details
        data.colId = 'details'
        if (data.fieldvalue === '') {
          this.$vs.notify({
            title: 'Warning',
            text: 'Details field must be greater than 0',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 8000,
            position: 'top-center'
          })
          return false
        }
      }
      this.update_user(data)
      
    },
    async update_user (data) {
      const project_id = data.proj_id
      const payload = {
        updateField: {
          [data.colId]: data.fieldvalue
        }
      }
      try {
        console.log(payload)
        const { data } = await projectUpdate(this.customer_id, project_id, payload)
        console.log(data)
        this.$vs.notify({
          title: 'Success',
          text: 'Project Updated Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (api_error) {
        console.log(api_error.message)

        this.$vs.notify({
          title: 'Warning',
          text: api_error.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000,
          position: 'top-center'
        })
      }

    },
    ProjecthandlePageChange (page) {
      setTimeout(() => {
        const queryPayloadString = Object.assign({}, this.$route.query)
        queryPayloadString.page = page
        queryPayloadString.limit = this.pageLimitSet
        queryPayloadString.customer_id = this.customer_id
        const pageScroll = document.documentElement.scrollTop
        this.$router
          .replace({ path: '/tasks-projects', query: queryPayloadString })
          .catch(() => {}).then(() => {
            document.documentElement.scrollTop = pageScroll
          })


        const queryPayload = Object.assign({}, this.$route.query)
        queryPayload.current_page = page
        queryPayload.limit = this.pageLimitSet
        queryPayload.customer_id = this.customer_id

        this.fetchProject(queryPayload)
      }, 0)
    },
    async fetchProject (query) {
      try {
        this.$vs.loading({
          type: 'radius'
        })
        const { data } = await projectList(query)
        const table = data.data.project
        this.meta = data.data.meta
        table.map((row, index) => {
          const row_index = index + 1
          Object.assign(row, { row_index })
        })
        this.$vs.loading.close()
        this.ListOfProject = table
        console.log(table)
      } catch (e) {
        console.log(e)
        this.$vs.loading.close()
      }
    }
  }
  

}
</script>